/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

export default $ => css`
    .rowProgress {
        font-size: 13px;
        padding: 4px;
    }

    .current_state {
        background-color: ${$.primaryMain};
        color: ${$.white};
        font-weight: 500;
    }

    .complete_state {
        background-color: ${$.infoMain};

        &.is-last-state {
            background-color: ${$.successMain};
        }
    }

    .next_state {
        background-color: ${$.gray100};
    }
`;
